module.exports = __webpack_public_path__ + "img/annaSpeaker.06a2fb09.png";